export default __webpack_public_path__ + "static/media/foreclosure.6cd5fd5e.png";